<template>
	<div>
		<!--  -->
		<div class="input_list">
			<el-button type="primary" size="small">添加角色</el-button>
		</div>
		<!--  -->
		<div class="usertable">
			<el-checkbox-group v-model="checkedlist">
				<el-table :header-cell-style="{ background: '#F2F2F4','text-align':'center'}"
					:cell-style="{'text-align':'center'}" ref="multipleTable" :data="tableData" tooltip-effect="dark"
					style="width: 100%">
					<el-table-column prop="date" label="角色" width="180"></el-table-column>
					<el-table-column prop="name" label="描述"></el-table-column>
					<el-table-column prop="name" label="操作" width="180">
						<div style="display: flex;">
							<div style="color: #409EFF;flex: 1;cursor: pointer;">查看</div>
							<div style="color: #FF0000;flex: 1;cursor: pointer;">删除</div>
						</div>
					</el-table-column>
				</el-table>
			</el-checkbox-group>
			<div class="pagescg">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page="currentPage4" :page-sizes="[100, 200, 300, 400]" :page-size="100"
					layout="total, sizes, prev, pager, next, jumper" :total="400"></el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				form: {},
				options: [{
					value: '选项1',
					label: '黄金糕'
				}, {
					value: '选项2',
					label: '双皮奶'
				}, {
					value: '选项3',
					label: '蚵仔煎'
				}, {
					value: '选项4',
					label: '龙须面'
				}, {
					value: '选项5',
					label: '北京烤鸭'
				}],
				checkedlist: [],
				activeName: "first",
				listtotal: 12345,
				value2: '',
				wenzi: '',
				tableData: [{
					id: 1,
					date: '1231fcr34312412',
					name: '王小虎',
					phone: '18116651137',
					store: '五月花店',
					hairs: 'tony',
					servise: '剪发',
					pay: 18,
					pingfen: '满意'
				}, {
					id: 2,
					date: '1231fcr34312412',
					name: '王小虎',
					phone: '18116651137',
					store: '五月花店',
					hairs: 'tony',
					servise: '剪发',
					pay: 18,
					pingfen: '满意'
				}, {
					id: 3,
					date: '1231fcr34312412',
					name: '王小虎',
					phone: '18116651137',
					store: '五月花店',
					hairs: 'tony',
					servise: '剪发',
					pay: 18,
					pingfen: '满意'
				}],
				// tabs 数据列表
				tabs: [{
					id: 0,
					value: '门店管理',
					isActive: true
				}, {
					id: 1,
					value: '加盟管理',
					isActive: false
				}, {
					id: 2,
					value: '门店指标',
					isActive: false
				}],
				//   tabs门店管理
				// 开业时间
				times: '',
				// 选择门店
				timeVal: '',
				storeval: [{
					label: '全部店铺',
					value: 1
				}, {
					label: '龙口西店',
					value: 2
				}, {
					label: '五月花店',
					value: 3
				}],
				// 选择状态
				stateVal: '',
				statelist: [{
					label: '状态',
					value: 1
				}, {
					label: '正常营业',
					value: 2
				}, {
					label: '门店撤店',
					value: 3
				}, {
					label: '即将开业',
					value: 4
				}, {
					label: '门店调休',
					value: 5
				}],
				// 店铺名称
				storeName: '',
				currentPage4: 4,
				chexknum: 12
			};
		},
		methods: {
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
			},
			// tabs切换点击事件
			tabsSwitch(id) {
				this.tabs.forEach((v, i) => (i === id ? (v.isActive = true) : (v.isActive = false)));
			}
		}
	};
</script>

<style lang="less" scoped>
	/deep/ .yxlabel {
		width: 20px;
		overflow: hidden;
	}

	.demotops {
		margin-bottom: 20px;
		width: 100%;
		height: 250px;
		background: #ECECEC;
		display: flex;
		padding: 30px;
		box-sizing: border-box;

		.demo1_card {
			width: 313px;
			height: 190px;

			img {
				width: 100%;
				height: 100%;
			}
		}

		.demo1_price {
			box-sizing: border-box;
			padding-top: 20px;
			margin-left: 40px;
			font-size: 18px;
			font-family: Source Han Sans CN;
			font-weight: 500;
			color: #444343;
			flex: 1;

			>div {
				&:nth-child(2) {
					margin-top: 15px;
				}
			}
		}

		.demo1_botton {
			margin-top: 80px;
		}

		// opacity: 0.51;
	}

	//输入框列表

	// 页码器
	.pagescg {
		margin-top: 10px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}

	// 表格
	.usertable {
		width: 100%;
		margin-top: 20px;

		.table_title {
			margin-bottom: 8px;
			font-size: 15px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #c9c9c9;
			width: 100%;
			text-align: right;
		}
	}

	.tablie_select {
		margin-top: 10px;
		display: flex;

		div {
			line-height: 30px;
		}
	}
</style>